import { CreditDriverApiClient } from "../src/creditDriverApiClient";

let client = new CreditDriverApiClient(process.env.VUE_APP_CANDIDATE_API);

export default {

    getCheckForCreditImprovementServiceId(candidateGuid) {
        return client.get('/CheckForCreditImprovementServiceId/' + candidateGuid);
    },
    getCheckForCreditImprovementServiceUsers(candidateGuid) {
        return client.get('/CheckForCreditImprovementServiceUsers/' + candidateGuid);
    },
    getCandidateCertificateFromCandidateId(data) {
        return client.post('/GetCandidateCertificateFromCandidateId', data);
    },
    getCandidateFromPhoneNumber(data) {
        return client.post('/GetCandidateFromPhoneNumber', data);
    },
    getCandidateFromCandidateGuid(data) {
        return client.post('/GetCandidateFromCandidateGuid', data);
    },
    getSecureCandidateFromCandidateGuid(data) {
        return client.post('/GetSecureCandidateFromCandidateGuid', data);
    },
    getCandidateFromSessionId(data) {
        return client.post('/GetCandidateFromSessionId', data);
    },
    getDealershipAndSalesPersonFromDealershipIdAndLeadGroupId(dealershipId, leadGroupId) {
        return client.get('/GetDealershipAndSalesPersonFromDealershipIdAndLeadGroupId/' + dealershipId + '/' + leadGroupId);
    },
    postGetSecureMFAStatus(data) {
        return client.post('/GetSecureMFAStatus', data);
    },    
    postGetSecureMFAStatusForLogin(data) {
        return client.post('/GetSecureMFAStatusForLogin', data);
    },
    postUpdateCandidate(data) {
        return client.post('/UpdateCandidate', data);
    },
    getInstaTouchIDGetCarrierUrl(dealershipUrlName, qrCodeGuid) {
        return client.get('/InstaTouchIDGetCarrierUrl/' + dealershipUrlName + '/' + qrCodeGuid);
    },
    postInstaTouchIDDetermineWorkflow(data) {
        return client.post('/InstaTouchIDDetermineWorkflow', data);
    },
    postInstaTouchIDSubmitConsentAndGetConsumerIdentity(data) {
        return client.post('/InstaTouchIDSubmitConsentAndGetConsumerIdentity', data);
    },
    postInstaTouchIDWiFiWorkflowSendOTP(data) {
        return client.post('/InstaTouchIDWiFiWorkflowSendOTP', data);
    },
    postInstaTouchIDWiFiWorkflowValidateOTP(data) {
        return client.post('/InstaTouchIDWiFiWorkflowValidateOTP', data);
    },
    postLoginWithSecureMFA(data) {
        return client.post('/LoginWithSecureMFA', data);
    },
    postSubmitCandidateInformationForCreditCheck(data) {
        return client.post('/SubmitCandidateInformationForCreditCheck', data);
    },
    postSubmitCandidateInformationForDITandSecureMFA(data) {
        return client.post('/SubmitCandidateInformationForDITandSecureMFA', data);
    },
    postSendCouponToDealership(data) {
        return client.post('/SendCouponToDealership', data);
    },
    postEmailCandiateCertificateToApplicant(data) {
        return client.post('/EmailCandiateCertificateToApplicant', data);
    }
    
}